<template>
  <el-dialog
    :title="$t('shopHouse.deleteConfirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{ $t('shopHouse.deleteShopHouseConfirm') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="danger" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopHouse } from '@/api/goods/shopHouseApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteShopHouse',
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        shId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteData = {
        shId: row.shId,
        shopId: getShopId()
      }
    },
    handleClose() {
      this.deleteData = {
        shId: '',
        shopId: ''
      }
    },
    async handleConfirm() {
      try {
        await deleteShopHouse(this.deleteData)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除仓库失败:', error)
        this.$message.error(error)
      }
    }
  }
}
</script>